import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-dot.tsx
/**
* icon.16.dot
*
* Keywords: circle, center, minimal, geometric, simple, round
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOCAxMGEyIDIgMCAxIDAgMC00IDIgMiAwIDAgMCAwIDQiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=157-5388
*/
const Icon16Dot = memo(function Icon16Dot(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Dot };

//# sourceMappingURL=icon-16-dot.js.map